"use strict";
import { GRID_SIZE } from "./constants";
export function snapToGrid(v) {
  return v.snap(GRID_SIZE);
}
export function getDisplayName(component) {
  return component.displayName || component.name || "Component";
}
